// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__AuZe9","col":"styles_col__3T_Ik","fulfillmentStatus":"styles_fulfillmentStatus__T4epa","emailCol":"styles_emailCol__2AyKw"};